import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

/**
 * PageHoverButton component - displays a hover button
 */
const PageHoverButton = ({ sitecoreContext }) => {
  return (
    <div className="page-hover-button">
      <button className="hover-btn">Hover Button</button>
    </div>
  );
};

export default withSitecoreContext()(PageHoverButton);
